import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentVariablesService } from '@kenv';
import { DataStoreService } from '@kservice';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseApi, RequestType } from './base.api';

const ALLOWED_ATTRIBUTION_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  // Affiliate referrer (e.g. ?ref=alice). Used for affiliate-marketing attribution.
  'ref',
];

@Injectable({
  providedIn: 'root',
})
export class AttributionApi extends BaseApi {
  constructor(
    client: HttpClient,
    dataStoreService: DataStoreService,
    environmentVariablesService: EnvironmentVariablesService
  ) {
    super(client, dataStoreService, environmentVariablesService);
  }

  async recordAttribution(queryParams: { [key: string]: unknown } | null | undefined, touchContext: string) {
    if (!queryParams) {
      return;
    }
    const body: { [key: string]: string } = {};
    for (const key of ALLOWED_ATTRIBUTION_KEYS) {
      const value = queryParams[key];
      if (typeof value === 'string' && value.trim().length > 0) {
        body[key] = value.trim().slice(0, 100);
      }
    }
    if (Object.keys(body).length === 0) {
      return;
    }
    body['touch_context'] = touchContext;

    const url = this.buildUrl('/attribution', true);
    if (!url) {
      return;
    }
    const request$ = this.performRequest(RequestType.POST, url, {
      includeToken: true,
      requestBody: body,
    }).pipe(
      catchError((error) => {
        console.warn('Failed recording attribution:', error);
        return of(null);
      })
    );
    await firstValueFrom(request$).catch((): null => null);
  }
}
